import { React, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
    Grid,
    Typography,
    Button,
    Paper,
    Divider,
    Snackbar,
    SnackbarContent,
    useTheme,
    useMediaQuery
} from "@mui/material"
import { Dialog, DialogContent, Tooltip, IconButton } from "@mui/material"

import useStyles, { CalendarCellStyles, DetailButtonGridStyles, DetailButtonStyles, DocumentItemStyles, DocumentTextGridStyles, PaperFirmNameStyles, PaperItemStyles } from "./ISOStyles"
import CalendarIcon from "../visitor/CalendarIcon"
import DocumentItemDialog from "./DocumentItemDialog"

function DocumentListItem({ documentObj }) {
    const dispatch = useDispatch()
    const theme = useTheme()

    // boolean flag for small screen size (mobile)
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false)
    }

    const handleSeeDetails = async () => {
        // get info regarding document
        setOpen(true)
    }

    const dateCreator = () => {
        if (documentObj?.DateImplemented) {
            const dashDate = documentObj.DateImplemented.substring(0, 10)

            const yearStr = dashDate.substring(0, 4)
            const monthStr = dashDate.substring(5, 7)
            const dateStr = dashDate.substring(8, 10)

            const slashDate = monthStr + "/" + dateStr + "/" + yearStr

            return new Date(slashDate)
        }
        return new Date()
        
    }

    return (
        <>
            <Grid
                container
                justifyContent="space-evenly"
                sx={DocumentItemStyles}
            >
                <Grid item size={1}>
                    <CalendarIcon dateObj={dateCreator()} />
                </Grid>
                <Grid item size={{ xs: 9, md: 10 }}>
                    <Paper sx={PaperItemStyles} elevation={3}>
                        <Grid container direction="row" justifyContent="center">
                            {/* <Typography
                                align="center"
                                sx={PaperFirmName}
                            >
                                {`REV ${documentObj.DocumentRevision}`}
                            </Typography> */}
                            <Grid
                                item
                                size={{ xs: 8, md: 9 }}
                                sx={DocumentTextGridStyles}
                            >
                                
                                <Typography
                                    align="center"
                                    variant="h5"
                                    sx={PaperFirmNameStyles}
                                >
                                    {isSmallScreen
                                        ? `${documentObj?.DocumentTitle?.slice(
                                              0,
                                              10
                                          ) || 'Title'}...`
                                        : documentObj?.DocumentTitle || 'Title'}
                                </Typography>
                                <Typography align="center">
                                    {isSmallScreen
                                        ? `${documentObj?.DocumentNumber}`
                                        : `${documentObj?.DocumentNumber} Rev ${documentObj?.DocumentRevision}`}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                size={3}
                                sx={DetailButtonGridStyles}
                            >
                                {isSmallScreen ? (
                                    <Button
                                        size="small"
                                        variant="contained"
                                        onClick={handleSeeDetails}
                                    >
                                        DETAILS
                                    </Button>
                                ) : (
                                    <Button
                                        size="small"
                                        variant="contained"
                                        sx={DetailButtonStyles}
                                        onClick={handleSeeDetails}
                                    >
                                        SEE DETAILS
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    maxWidth="sm"
                    fullWidth={true}
                >
                    <DialogContent sx={{ height: "570px" }}>
                        <DocumentItemDialog documentObj={documentObj} />
                    </DialogContent>
                </Dialog>
            </Grid>
        </>
    )
}

export default DocumentListItem
